export default __webpack_public_path__ + "static/media/tinder.1e145fa3.png";